module.exports = __webpack_public_path__ + "static/img/recharge.fc61fc90.png";